/**
 * Script for the Front Page
 *
 * @author Space-Time Inc.
 * @version 2024-02-10
 */

